import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { ILogin, IPermissionProps } from "../../../models/Login";
import { Fetch } from "../../../shared/Fetch";
import { Filter } from "../Filter";
import { Publish } from "../Publish";
import { Submission } from "../recruiter/Submission";
import { IRecruiterRequirements } from "../../../models/RecruiterRequirements";
import { IModel2 } from "../sales/TableAll";
import { IReqFilter, EmptyFilter } from "../Filter";
import { Tag } from "primereact/tag";
import { ReqQuery } from "../ReqQuery";
import { Accordion, AccordionTab } from "primereact/accordion";
import { format } from "date-fns";
import { Dialog } from "primereact/dialog";
import { BenchConsultantList } from "./BenchConsultantList";
import { User } from "../../jvConnect/User";
import { Req_Term } from "../../../models/RequirementMast";

interface Iprops {
    toast: any,
    permissions: IPermissionProps,
    reload: boolean,
    setReload: (is: boolean) => void,
    ShowCelebration: () => void
}

export const Table = (props: Iprops) => {
    const [tableMyData, setTableMyData] = useState({ tableData: [], loading: false } as { tableData: Array<IRecruiterRequirements>, loading: boolean });
    const [reqFilter, setReqFilter] = useState<IReqFilter>(EmptyFilter);
    const [floatReqSubModal, setFloatReqSubModal] = useState<boolean>(false);
    const [consultantListModal, setConsultantListModal] = useState({ open: false, singleData: {}, req_ID: 0 } as { open: boolean, singleData: any, req_ID: number });
    const dt = useRef<any>(null);

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const [publish, setPublish] = useState({ singleData: {}, open: false } as IModel2);
    const hidePublishDialog = () => {
        setPublish({ singleData: {}, open: false });
    };
    // const [filter, setFilter] = useState(false);
    // const hideFilterDialog = () => {
    //     setFilter(false);
    // };
    const [submission, setSubmission] = useState({ singleData: {}, open: false } as IModel2);
    const hideSubmissionDialog = () => {
        setSubmission({ singleData: {}, open: false });
    };
    const [query, setQuery] = useState({ req_id: 0, open: false } as { req_id: number, open: boolean });
    const hideQueryDialog = () => {
        setQuery({ req_id: 0, open: false });
    };

    useEffect(() => {
        loadTableData();
    }, [reqFilter, props.reload]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableMyData({ tableData: tableMyData.tableData, loading: true });
        const response = await Fetch("Requirement_MAST", "GET", null, `filter=` + encodeURIComponent(JSON.stringify(reqFilter)) + `&tb=${1}&bench=1`, props.toast);
        if (response) {
            const data: Array<IRecruiterRequirements> = await response.json();
            setTableMyData({ tableData: data, loading: false });
        } else setTableMyData({ tableData: tableMyData.tableData, loading: false });
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button icon="pi pi-refresh" className="p-button-rounded p-button-info mr-2" onClick={() => props.setReload(!props.reload)} />
            </React.Fragment>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            props.permissions.is_Export ?
                <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help my-2" onClick={exportCSV} />
                </React.Fragment> : ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Bench Requirements</h5>
        </div>
    );

    const m_req_ID = (rowData: IRecruiterRequirements) => {
        return (!rowData.hold ?
            <span onClick={() => setSubmission({ singleData: rowData, open: true })}
                className="cursor-pointer text-cyan-700 underline">
                {rowData.req_ID}
            </span>
            : <span>{rowData.req_ID}</span>);
        // return (props.permissions.is_Create && (rowData.hold === "Unhold" || rowData.hold === null) && (rowData?.referred_By === null || rowData?.referred_By === 0) ?
        //     <span onClick={() => setSubmission({ singleData: rowData, open: true })}
        //         className="cursor-pointer text-cyan-700 underline">
        //         {rowData.req_ID}
        //     </span>
        //     : <span>{rowData.req_ID}</span>);
    };
    const m_req_Job_Title = (rowData: IRecruiterRequirements) => {
        return rowData.req_EditedBy ? <span onClick={() => setPublish({ singleData: rowData, open: true })}
            className="cursor-pointer underline">
            <Tag severity="warning" value={rowData.req_Job_Title} />
        </span> : <span onClick={() => setPublish({ singleData: rowData, open: true })}
            className="cursor-pointer text-cyan-700 underline">
            {rowData.req_Job_Title}
        </span>;
    };
    const actionBodyTemplate = (rowData: IRecruiterRequirements) => {
        if (props.permissions.is_Create) {
            return <Button label="V&Q" className="p-button-rounded p-button-text" onClick={() => { if (rowData.req_ID) setConsultantListModal({ open: true, singleData: rowData, req_ID: rowData.req_ID }) }} />
        } else {
            return <></>
        }
    };

    const onHideFloatSubModal = () => {
        setFloatReqSubModal(false);
    };
    const onHideConsultantListModal = () => {
        setConsultantListModal({ open: false, singleData: {}, req_ID: 0 });
        console.log('onHideConsultantListModal');
    };
    const rowClass = (data: any) => {
        return {
            'bg-orange-100 font-semibold': data.reqType_ID === 1,
        };
    };
    // const consultatnByCategoryList = (rowData: any) => {
    //     return <span onClick={() => setConsultantListModal({ open: true, singleData: rowData, req_ID: rowData.req_ID })} className="cursor-pointer text-cyan-700 underline">{rowData.req_CategoryName}</span>;
    // };
    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter reqFilter={reqFilter} setReqFilter={(reqFilter: IReqFilter) => setReqFilter(reqFilter)} ft={2} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableMyData.tableData} emptyMessage="No Requirements found."
                header={header} loading={tableMyData.loading}
                rowClassName={rowClass}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="req_ID" header="Req.ID" sortable />
                <Column field="req_Job_Title" sortable header="Job Title" body={m_req_Job_Title} />
                <Column field="user_Name" sortable header="Sales Manager"
                    body={(r: IRecruiterRequirements) => <User req={{
                        reqId: r.req_ID ?? '',
                        jobTitle: r.req_Job_Title ?? '',
                        postedDate: r.pDate ?? '',
                        userId: r.req_PostedBySalesManager ?? 0,
                        userName: r.user_Name ?? '',
                    }}
                    />} />
                <Column field="salesCompany" header="Sales Comp(Branch)" body={(rowData: any) => <p>{rowData.salesCompany}</p>} />
                <Column field="req_Duration" header="Duration" />
                <Column field="location" header="Location" />
                <Column field="rate" header="Rate" />
                <Column field="req_Term" header="Term" body={(rowData: IRecruiterRequirements) => rowData.req_Term ? Req_Term[rowData.req_Term] : ""} />
                <Column field="req_CategoryName" header="Category" style={{ maxWidth: "8rem", overflow: "hidden" }} sortable />
                <Column field="req_Sub_CategoryName" header="Sub Category" style={{ maxWidth: "8rem", overflow: "hidden" }} sortable />
                <Column field="client" sortable header="Client" />
                <Column field="litency" header="Latency" />
                <Column field="req_RequiredSkill" header="Req Keyword" />
                <Column field="hold" header="Status" body={(rowData: IRecruiterRequirements) => rowData.hold ? "Hold" : "Unhold"} />
                <Column field="max_Submission" header="Max Submission" />
                <Column body={actionBodyTemplate} header="Action" />
            </DataTable>
            {/* <Filter hideDialog={hideFilterDialog} open={filter} toast={props.toast} setReqFilter={(reqFilter: IReqFilter) => setReqFilter(reqFilter)} ft={2} /> */}
            <Publish singleData={publish.singleData} open={publish.open} hideDialog={hidePublishDialog} toast={props.toast} />
            <ReqQuery open={query.open} req_id={query.req_id} hideDialog={hideQueryDialog} toast={props.toast} />
            <Submission singleData={submission.singleData} open={submission.open} hideDialog={hideSubmissionDialog} toast={props.toast} ShowCelebration={props.ShowCelebration} />
            <Dialog visible={consultantListModal.open} style={{ width: '80vw' }} header="Consultant List" className="p-fluid" maximizable onHide={onHideConsultantListModal}>
                <BenchConsultantList open={consultantListModal.open} req_ID={consultantListModal.req_ID} toast={props.toast} singleData={consultantListModal.singleData} hideDialog={onHideConsultantListModal} />
            </Dialog>
        </>
    );
}
